import * as UI from "@iyk/ui"

export function PlayPauseButton({ isPlaying, isBuffering, onClick }: PlayPauseButton.Props) {
  return (
    <button
      disabled={isBuffering}
      className={UI.cx([
        "bg-gray-12 rounded-full size-11 flex items-center justify-center",
        "disabled:opacity-50 disabled:cursor-not-allowed"
      ])}
      onClick={(e) => {
        e.stopPropagation()
        onClick(e)
      }}
    >
      {isPlaying && !isBuffering ? (
        <UI.Icon.Pause className="size-5 text-gray-1" />
      ) : isBuffering ? (
        <UI.Icon.LoadingSpinner className="size-5 text-gray-1" />
      ) : (
        <UI.Icon.Play className="size-6 text-gray-1" />
      )}
    </button>
  )
}

namespace PlayPauseButton {
  export type Props = {
    isPlaying: boolean
    isBuffering?: boolean
    onClick: (e: React.MouseEvent<HTMLButtonElement>) => void
  }
}
